













































































































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import Video from "@/components/Video.vue";
import { BIcon, BIconUpload } from "bootstrap-vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Header,
    Menu,
    Video,
    BIcon,
    BIconUpload,
    NextPrevBtn,
    Footer
  }
})
export default class ArtPerfStudents extends Vue {
  protected videoPerf = [
    {
      videoSrc: "https://www.youtube.com/embed/fizlZKMboSE",
      videoTitle: "Océans Bienséants",
      videoRoot: "Contenu soumis à des droits d'auteur"
    },
    {
      videoSrc: "https://www.youtube.com/embed/uxf2s2HgSqw",
      videoTitle: "Jetez-moi",
      videoRoot: "Contenu soumis à des droits d'auteur"
    },
    {
      videoSrc: "https://www.youtube.com/embed/juhGAAl08zw",
      videoTitle: "Évolution technologique et corps",
      videoRoot: "Contenu soumis à des droits d'auteur"
    },
    {
      videoSrc: "https://www.youtube.com/embed/jKJ6cm-zUdM",
      videoTitle: "Du champ des possibles",
      videoRoot: "Contenu soumis à des droits d'auteur"
    },
    {
      videoSrc: "https://youtube.com/embed/yD9pcWDJt84",
      videoTitle: "Cacophonie Écologique",
      videoRoot: "Contenu soumis à des droits d'auteur"
    },
    {
      videoSrc: "https://youtube.com/embed/5cJ6BVc-ZHw",
      videoTitle: "Votez Futile",
      videoRoot: "Contenu soumis à des droits d'auteur"
    }
  ];
  protected nxtprevArtPerfStudents = {
    BoolPrev: true,
    BoolNext: true,
    PrevImage: "/thumbnail7.png",
    NextImage: "/thumbnail2.png",
    PrevLink: "/PerformanceArtistique/Origines",
    NextLink: "/PerformanceArtistique/CorpusdeTexte"
  };
}
